module.exports = __webpack_public_path__ + "static/media/icon-lp-therapy.52b75f82.svg";